"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upsertOrderFixtures = void 0;
exports.upsertOrderFixtures = {
    hasError: false,
    order: {
        id: "Order:40"
    }
};
